/**
 * This file defines global constants which should be importable.
 */
const Constants = {
  menu: {
    type: {
      group: 1,
      reports: 2,
      link: 3,
      'dynamic Carrier': 4,
      'dyanmic Plans': 5,
      vendor: 6,
    },
    icon: {
      1: {
        name: 'Folder',
        value: 'fa fa-folder',
      },
      2: {
        name: 'Document',
        value: 'fa fa-file',
      },
      3: {
        name: 'Certify',
        value: 'fas fa-certificate',
      },
      4: {
        name: 'Institution',
        value: 'fas fa-university',
      },
      5: {
        name: 'Calendar',
        value: 'far fa-calendar',
      },
      6: {
        name: 'Calendar Day',
        value: 'fas fa-calendar-day',
      },
      7: {
        name: 'Event',
        value: 'far fa-calendar-check',
      },
      8: {
        name: 'Service',
        value: 'fas fa-portrait',
      },
      9: {
        name: 'People',
        value: 'fas fa-user-friends',
      },
      10: {
        name: 'Issue',
        value: 'fas fa-exclamation-circle',
      },
    },
    itemTypes: {
      group: 1,
      reports: 2,
      link: 3,
      carrier: 4,
      'dyanmic Plans': 5,
      vendor: 6,
    },
  },
  reports: {
    monthly_report: {
      1: {
        code: 'MBR',
      },
      2: {
        code: 'MCR',
      },
    },
  },
  documents: {
    default_user_upload_type: 'USR',
  },
  terminationReasons: [
    { label: 'Retirement', value: 0 },
    { label: 'Voluntary', value: 1 },
    { label: 'Involuntary', value: 2 },
    { label: 'Death', value: 3 },
    { label: 'Disabled', value: 4 },
    { label: 'For Cause', value: 5 },
    { label: 'Change in Control', value: 6 },
  ],
  questionnaireStatus: {
    0: { name: 'Unsent', value: 'Unsent' },
    1: { name: 'Sent', value: 'Sent' },
    2: { name: 'Returned', value: 'Returned' },
    3: { name: 'Approved For Upload', value: 'ApprovedForUpload' },
    4: { name: 'Uploaded', value: 'Uploaded' },
  },
  reportEnum: {
    assetReport: 10,
    assetReportSummary: 15,
    _8925Report: 20,
    annualBoliReview: 30,
  },
  auditActionsEventTypes: {
    CLICK: 'CLICK',
    PREVIEW: 'PREVIEW',
    DOWNLOAD: 'DOWNLOAD',
    PRINT: 'PRINT',
  },
  trackableDocumentTypes: {
    assetReport: 'MBR',
    assetReportSummary: 'SMB',
    _8925Report: 'BTX',
  },
  permissions: [
    { id: 0, name: 'Client Reports', code: 'CLIENT_REPORTS' },
    { id: 1, name: 'Document Center', code: 'DOCUMENT_CENTER' },
    { id: 2, name: 'Announcements', code: 'ANNOUNCEMENTS' },
    { id: 3, name: 'Email Templates', code: 'EMAIL_TEMPLATES' },
    { id: 4, name: 'Carriers', code: 'CARRIERS' },
    { id: 5, name: 'Institutions', code: 'INSTITUTIONS' },
    { id: 6, name: 'Report Types', code: 'REPORT_TYPES' },
    { id: 7, name: 'Client Menu', code: 'CLIENT_MENU' },
    { id: 8, name: 'Sites', code: 'SITES' },
    { id: 9, name: 'Permission Templates', code: 'PERMISSION_TEMPLATES' },
    { id: 10, name: 'Users', code: 'USERS' },
    { id: 11, name: 'Activity Report', code: 'ACTIVITY_REPORT' },
    { id: 12, name: 'Asset Reporting', code: 'ASSET_REPORT' },
    { id: 14, name: 'Report Configuration', code: 'REPORT_CONFIGURATION' },
    { id: 15, name: '8925 Reporting', code: 'C8925_REPORT' },
    { id: 16, name: 'Summary Asset Report', code: 'ASSET_SUMMARY_REPORT' },
    { id: 17, name: 'Annual Questionnaire', code: 'ANNUAL_QUESTIONNAIRE' },
    { id: 18, name: 'Annual Boli Review', code: 'ANNUAL_BOLI_REVIEW' },
    { id: 19, name: 'Audit Actions', code: 'AUDIT_ACTIONS' },
    { id: 20, name: 'Email Sending Log', code: 'EMAIL_SENDING_LOG' },
  ],
  sessionCookieNames: [
    '.bcc-usa.auth.SESSION.PROD',
    '.bcc-usa.auth.REMEMBER-ME.PROD',
    '.bcc-usa.auth.PROD',

    '.bcc-usa.auth.SESSION.QA',
    '.bcc-usa.auth.REMEMBER-ME.QA',
    '.bcc-usa.auth.QA',

    '.bcc-usa.auth.SESSION.STG',
    '.bcc-usa.auth.REMEMBER-ME.STG',
    '.bcc-usa.auth.STG',

    '.bcc-usa.auth.SESSION.DEV',
    '.bcc-usa.auth.REMEMBER-ME.DEV',
    '.bcc-usa.auth.DEV',
  ],
  tinyMceBasicConfig: {
    height: 300,
    menubar: false,
    onboarding: false,
    content_style: 'body { font-family: Calibri, sans-serif; }',
    font_family_formats: 'Calibri=calibri,sans-serif; Arial=arial,helvetica,sans-serif; Times New Roman=times new roman,times,serif',
    branding: false,
    plugins: ['lists', 'paste', 'code', 'link', 'table', 'wordcount'],
    toolbar: 'undo redo | fontfamily fontsize code link bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
  },
}

export default Constants
